module.exports = __webpack_public_path__ + "static/media/sf-trial-1.f364b5c4.mp3";